{{ freight.status }}
@if (freight.status !== EFreightStatus.DEFAULT) {
  <div class="bar-steps-indicator">
    @for (stop of freight.stopsDetailed; track stop.id) {
      <button
        (click)="goToDetailStop(stop.id)"
        [ngClass]="{
          'to-load': stop.id === freight.nextStopId && stop.type === EStopType.LOAD,
          'to-unload': stop.id === freight.nextStopId && stop.type === EStopType.UNLOAD,
          'to-unload_load': stop.id === freight.nextStopId && stop.type === EStopType.UNLOAD_LOAD,
        }"
      >
        {{ stop.position + 1 }}
      </button>
    }
    <div class="line"></div>
  </div>

  <lib-message-ui-ionic [messages]="messages"></lib-message-ui-ionic>

  <ion-list class="block-content-round">
    <ion-item-group>
      <ion-item-divider sticky>
        <div>
          <p class="subtitle">{{ 'freight.detail.general_data' | translate }}</p>
        </div>
      </ion-item-divider>

      <div class="freight">
        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col
              size="12"
              size-lg="6"
            >
              <div
                class="freight-data-block status"
                [ngClass]="{
                  'offer-requested': freight.status === EFreightStatus.OFFER_REQUESTED,
                  'offer-sent': freight.status === EFreightStatus.OFFER_SENT,
                  assigned: freight.status === EFreightStatus.ASSIGNED,
                  'on-route': freight.status === EFreightStatus.ON_ROUTE,
                  finished: freight.status === EFreightStatus.FINISHED,
                  cancelled: freight.status === EFreightStatus.CANCELLED,
                }"
              >
                @if (freight.status === EFreightStatus.OFFER_REQUESTED) {
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/arrow_upward_24dp.svg"
                  ></ion-icon>
                }
                @if (freight.status === EFreightStatus.OFFER_SENT) {
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/payments_24dp.svg"
                  ></ion-icon>
                }
                @if (freight.status === EFreightStatus.ASSIGNED) {
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/play_circle_24dp.svg"
                  ></ion-icon>
                }
                @if (freight.status === EFreightStatus.ON_ROUTE) {
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/arrow_circle_right_24dp.svg"
                  ></ion-icon>
                }
                @if (freight.status === EFreightStatus.FINISHED) {
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/task_alt_24dp.svg"
                  ></ion-icon>
                }
                @if (freight.status === EFreightStatus.CANCELLED) {
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/cancel_24dp.svg"
                  ></ion-icon>
                }
                <div>
                  <p>
                    <strong>{{ 'freight.detail.status.' + freight.status | translate }}</strong>
                  </p>
                </div>
              </div>
            </ion-col>
            <ion-col
              size="12"
              size-lg="6"
            >
              <div class="freight-data-block">
                <ion-icon
                  aria-hidden="true"
                  src="../assets/material-symbols/qr_code_24dp.svg"
                ></ion-icon>
                <div>
                  <p class="subtitle">{{ 'freight.detail.reference' | translate }}</p>
                  <p>{{ freight.reference }}</p>
                </div>
              </div>
            </ion-col>
            <ion-col
              size="12"
              size-lg="6"
            >
              <div class="freight-data-block">
                <ion-icon
                  aria-hidden="true"
                  src="../assets/material-symbols/barcode_24dp.svg"
                ></ion-icon>
                <div>
                  <p class="subtitle">{{ 'freight.detail.okcargo_reference' | translate }}</p>
                  <p>{{ freight.okcargoReference }}</p>
                </div>
              </div>
            </ion-col>
            <ion-col
              size="12"
              size-lg="6"
            >
              <div class="freight-data-block">
                <ion-icon
                  aria-hidden="true"
                  src="../assets/material-symbols/local_shipping_24dp.svg"
                ></ion-icon>
                <div>
                  <p class="subtitle">{{ 'freight.detail.vehicle_type' | translate }}</p>
                  <p>
                    @for (vehicleType of freight.vehicleTypes; track $index) {
                      <strong>{{ 'vehicleType.' + vehicleType | translate }}</strong>
                      ,
                    }
                    @for (loadingType of freight.loadingTypes; track $index; let count = $count) {
                      @if ($index < count - 1) {
                        {{ 'freight.detail.loading_type.' + loadingType | translate | lowercase }},
                      } @else {
                        {{ 'freight.detail.loading_type.' + loadingType | translate | lowercase }}
                      }
                    }
                  </p>
                </div>
              </div>
            </ion-col>
            @if (freight.vehicles.length > 0) {
              <ion-col
                size="12"
                size-lg="6"
              >
                <div class="freight-data-block">
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/okc_assigned_vehicle_24dp.svg"
                  ></ion-icon>
                  <div>
                    <p class="subtitle">{{ 'freight.detail.asigned_vehicle' | translate }}</p>
                    @for (vehicle of freight.vehicles; track vehicle.id) {
                      <p>
                        <span class="plate">{{ vehicle.plate }}</span>
                        {{ 'vehicleType.' + vehicle.type | translate }}
                      </p>
                    }
                  </div>
                </div>
              </ion-col>
            }
            @if (freight.instructions !== undefined) {
              <ion-col
                size="12"
                size-lg="6"
              >
                <div class="freight-data-block">
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/info_24dp.svg"
                  ></ion-icon>
                  <div>
                    <p class="subtitle">{{ 'freight.detail.instructions' | translate }}</p>
                    @if (freight.instructions !== undefined) {
                      <p>{{ freight.instructions }}</p>
                    }
                  </div>
                </div>
              </ion-col>
            }

            @if (freight.price) {
              <ion-col
                size="12"
                size-lg="6"
              >
                <div class="freight-data-block">
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/payments_24dp.svg"
                  ></ion-icon>
                  <div>
                    <p class="subtitle">{{ 'freight.detail.price' | translate }}</p>
                    <p>{{ freight.price | number: '1.2-2' }} €</p>
                  </div>
                </div>
              </ion-col>
            }

            @if (freight.digitizedDeliveryNotes.length > 0) {
              <ion-col
                size="12"
                size-lg="6"
              >
                <div class="freight-data-block">
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/file_copy_24dp.svg"
                  ></ion-icon>
                  <div>
                    <p class="subtitle">{{ 'freight.detail.digitized_delivery_notes' | translate }}</p>

                    <ion-list lines="full">
                      @for (deliveryNote of freight.digitizedDeliveryNotes; track deliveryNote.id) {
                        <ion-item
                          button
                          detail="true"
                          detail-icon="../assets/material-symbols/visibility_24dp.svg"
                          (click)="downloadDocument(deliveryNote.url, deliveryNote.name)"
                          target="_blank"
                        >
                          <ion-label>{{ deliveryNote.name }}</ion-label>
                        </ion-item>
                      }
                    </ion-list>
                  </div>
                </div>
              </ion-col>
            }
          </ion-row>
        </ion-grid>
      </div>
    </ion-item-group>
  </ion-list>

  @for (stop of freight.stopsDetailed; track stop.id) {
    <ion-list
      [id]="stop.id"
      class="block-content-round"
      [ngClass]="{
        '--to-load': stop.type === EStopType.LOAD,
        '--to-unload': stop.type === EStopType.UNLOAD,
        '--to-unload_load': stop.type === EStopType.UNLOAD_LOAD,
        '--active': freight.nextStopId === stop.id && stop.status !== EStopStatus.FINISHED,
      }"
    >
      <ion-item-group>
        <ion-item-divider sticky>
          <div>
            <span class="step-number">{{ stop.position + 1 }}</span>
            <p class="subtitle">
              @if (stop.type === EStopType.LOAD) {
                {{ 'freight.detail.load' | translate }}
              } @else if (stop.type === EStopType.UNLOAD) {
                {{ 'freight.detail.unload' | translate }}
              } @else if (stop.type === EStopType.UNLOAD_LOAD) {
                {{ 'freight.detail.unload_load' | translate }}
              }
            </p>
          </div>
          @if (stop.type === EStopType.LOAD) {
            <ion-icon
              slot="end"
              aria-hidden="true"
              src="../assets/material-symbols/upload_24dp.svg"
            ></ion-icon>
          } @else if (stop.type === EStopType.UNLOAD) {
            <ion-icon
              slot="end"
              aria-hidden="true"
              src="../assets/material-symbols/download_24dp.svg"
            ></ion-icon>
          } @else if (stop.type === EStopType.UNLOAD_LOAD) {
            <ion-icon
              slot="end"
              aria-hidden="true"
              src="../assets/material-symbols/swap_vert_24dp.svg"
            ></ion-icon>
          }
        </ion-item-divider>

        <div class="freight">
          <ion-grid class="ion-no-padding">
            <ion-row>
              <ion-col
                size="12"
                size-lg="6"
              >
                <div class="freight-data-block">
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/pin_drop_24dp.svg"
                  ></ion-icon>

                  <div>
                    <p class="fs-sm">
                      {{ stop.address.company }}
                    </p>
                    <p>{{ stop.address.street }}</p>
                    @if (stop.address.extraLine) {
                      <p>{{ stop.address.extraLine }}</p>
                    }
                    <p>{{ stop.address.postalCode }} {{ stop.address.city }}</p>
                    <p class="ion-text-uppercase">
                      <strong>
                        ({{ 'countries.' + stop.address.countryCode | translate }})
                        {{ 'states.' + stop.address.countryCode + stop.address.stateCode | translate }}
                      </strong>
                    </p>
                    @if (stop.address.coords) {
                      <ion-button
                        fill="outline"
                        color="primary"
                        size="small"
                        (click)="openMap(stop.address.coords)"
                      >
                        <ion-icon
                          aria-hidden="true"
                          slot="start"
                          src="../assets/material-symbols/map_24dp.svg"
                        ></ion-icon>
                        {{ 'freight.detail.map' | translate }}
                      </ion-button>
                    }
                  </div>
                </div>

                @if (stop.arrivalDriverAppPoint) {
                  <div class="freight-data-block">
                    <ion-icon
                      aria-hidden="true"
                      src="../assets/material-symbols/where_to_vote_24dp.svg"
                    ></ion-icon>
                    <div>
                      <p class="subtitle">{{ 'freight.detail.coords_app' | translate }}</p>
                      <p class="fs-sm">
                        {{ stop.arrivalDriverAppPoint.latitude }}, {{ stop.arrivalDriverAppPoint.longitude }}
                      </p>
                    </div>
                  </div>
                }

                <div class="freight-data-block">
                  <ion-icon
                    aria-hidden="true"
                    src="../assets/material-symbols/schedule_24dp.svg"
                  ></ion-icon>

                  <div>
                    <p class="subtitle">{{ 'freight.detail.schedule' | translate }}:</p>

                    <ion-grid>
                      <ion-row>
                        <ion-col>{{ 'freight.detail.expected_arrival' | translate }}:</ion-col>
                        <ion-col class="ion-text-end">{{ stop.since | dfnsFormat: 'ccc Pp' }}&nbsp;h</ion-col>
                      </ion-row>
                      <ion-row>
                        <ion-col>{{ 'freight.detail.expected_departure' | translate }}:</ion-col>
                        <ion-col class="ion-text-end">{{ stop.until | dfnsFormat: 'ccc Pp' }}&nbsp;h</ion-col>
                      </ion-row>
                    </ion-grid>
                  </div>
                </div>

                @if (stop.arrivedAt || stop.departedAt) {
                  <div class="freight-data-block">
                    <ion-icon
                      aria-hidden="true"
                      src="../assets/material-symbols/schedule_24dp.svg"
                    ></ion-icon>

                    <div>
                      <p class="subtitle">{{ 'freight.detail.realized_schedule' | translate }}:</p>
                      <ion-grid>
                        @if (stop.arrivedAt) {
                          <ion-row>
                            <ion-col>
                              <strong>{{ 'freight.detail.arrival_at_stop' | translate }}:</strong>
                            </ion-col>
                            <ion-col class="ion-text-end fw-700">
                              {{ stop.arrivedAt | dfnsFormat: 'ccc Pp' }}&nbsp;h
                            </ion-col>
                          </ion-row>
                        }
                        @if (stop.departedAt) {
                          <ion-row>
                            <ion-col>
                              <strong>{{ 'freight.detail.stop_departure' | translate }}:</strong>
                            </ion-col>
                            <ion-col class="ion-text-end fw-700">
                              {{ stop.departedAt | dfnsFormat: 'ccc Pp' }}&nbsp;h
                            </ion-col>
                          </ion-row>
                        }
                      </ion-grid>
                    </div>
                  </div>
                }
              </ion-col>
              <ion-col
                size="12"
                size-lg="6"
              >
                @if (stop.reference !== undefined) {
                  <div class="freight-data-block">
                    <ion-icon
                      aria-hidden="true"
                      src="../assets/material-symbols/barcode_24dp.svg"
                    ></ion-icon>
                    <div>
                      <p class="subtitle">{{ 'freight.detail.stop_reference' | translate }}</p>
                      <p class="fs-sm">{{ stop.reference }}</p>
                    </div>
                  </div>
                }

                @if (
                  stop.unloadedPackages !== undefined ||
                  stop.netWeight !== undefined ||
                  stop.packages !== undefined ||
                  stop.unloadedNetWeight !== undefined ||
                  stop.unloadedPackages !== undefined ||
                  stop.goodsDescription !== undefined
                ) {
                  <div class="freight-data-block">
                    <ion-icon
                      aria-hidden="true"
                      src="../assets/material-symbols/summarize_24dp.svg"
                    ></ion-icon>
                    <div>
                      <p class="subtitle">{{ 'freight.detail.shipment_data' | translate }}</p>
                      <ion-grid>
                        @if (stop.netWeight !== undefined) {
                          <ion-row>
                            <ion-col>{{ 'freight.detail.weight' | translate }}</ion-col>
                            <ion-col class="ion-text-end">{{ stop.netWeight }} kg</ion-col>
                          </ion-row>
                        }
                        @if (stop.packages !== undefined) {
                          <ion-row>
                            <ion-col>{{ 'freight.detail.packages' | translate }}</ion-col>
                            <ion-col class="ion-text-end">{{ stop.packages }}</ion-col>
                          </ion-row>
                        }
                        @if (stop.unloadedNetWeight !== undefined) {
                          <ion-row>
                            <ion-col>{{ 'freight.detail.unloaded_weight' | translate }}</ion-col>
                            <ion-col class="ion-text-end">{{ stop.unloadedNetWeight }}</ion-col>
                          </ion-row>
                        }
                        @if (stop.unloadedPackages !== undefined) {
                          <ion-row>
                            <ion-col>{{ 'freight.detail.unloaded_packages' | translate }}</ion-col>
                            <ion-col class="ion-text-end">{{ stop.unloadedPackages }}</ion-col>
                          </ion-row>
                        }
                        @if (stop.goodsDescription !== undefined) {
                          <ion-row>
                            <ion-col>{{ 'freight.detail.goods' | translate }}</ion-col>
                            <ion-col class="ion-text-end">{{ stop.goodsDescription }}</ion-col>
                          </ion-row>
                        }
                      </ion-grid>
                    </div>
                  </div>
                }

                @if (stop.instructions !== undefined && stop.instructions !== '') {
                  <div class="freight-data-block">
                    <ion-icon
                      aria-hidden="true"
                      src="../assets/material-symbols/comment_24dp.svg"
                    ></ion-icon>
                    <div>
                      <p class="subtitle">{{ 'freight.detail.instructions' | translate }}</p>
                      <p>{{ stop.instructions }}</p>
                    </div>
                  </div>
                }

                @if (stop.reservations !== undefined && stop.reservations !== '') {
                  <div class="freight-data-block">
                    <ion-icon
                      aria-hidden="true"
                      src="../assets/material-symbols/comment_24dp.svg"
                    ></ion-icon>
                    <div>
                      <p class="subtitle">{{ 'freight.detail.noted_reservations' | translate }}</p>
                      <p>{{ stop.reservations }}</p>
                    </div>
                  </div>
                }
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>
      </ion-item-group>
    </ion-list>
  }
} @else {
  <lib-skeleton-card-two-columns></lib-skeleton-card-two-columns>
  <lib-spinner-loading></lib-spinner-loading>
  <lib-skeleton-card-generic></lib-skeleton-card-generic>
}
